import * as Yup from 'yup';

export const CloseDefinitivelySchema = Yup.object().shape({
    blendIds: Yup.array().required('Required'),
    reason: Yup.string().max(500, 'Too Long!').required('Required'),
});
